// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h4ztl","left":"styles_left__PVxJV"};